var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdCampaignFormBase',{attrs:{"ad-campaign-entry":_vm.adCampaignEntry,"save-loading-entry":_vm.editLoading,"is-edit-form":""},on:{"item:submit":_vm.updateEventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }